import { Grid, Box } from "@chakra-ui/react";
import { useBreadcrumb } from "features/breadcrumbs";
import MenuDetalhes from "components/Menu/MenuDetalhes";
import DadosPessoaisTab from "./DadosPessoaisTab";
import { useState } from "react";
import EnderecoTab from "./EnderecoTab";
import { useLocation } from "react-router-dom";
import TrocarSenhaTab from "./TrocarSenhaTab";
import Container from 'components/Container';

export enum PerfilTabsRoutes {
  DadosPessoais = "dados-pessoais",
  Endereco = "endereco",
  TrocarSenha = "trocar-senha",
}

const tabs = [
  {
    label: "Dados pessoais",
    route: PerfilTabsRoutes.DadosPessoais,
    permissions: [],
  },
  {
    label: "Endereço",
    route: PerfilTabsRoutes.Endereco,
    permissions: [],
  },
  {
    label: "Trocar senha",
    route: PerfilTabsRoutes.TrocarSenha,
    permissions: [],
  },
];

function EditarPerfilTabs() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const tab = params.get("tab") as PerfilTabsRoutes | null;
  const [selectedTab, setSelectedTab] = useState<PerfilTabsRoutes>(
    tab || PerfilTabsRoutes.DadosPessoais
  );
  useBreadcrumb([{ name: "Editar perfil", url: "/editar-perfil" }]);

  return (
    <Container>
      <Grid templateColumns="1fr 4fr" gridGap={4} mt={8}>
        <Box h="fit-content">
          <MenuDetalhes
            options={tabs}
            selectedOption={selectedTab}
            onChangeOption={(tab) => {
              setSelectedTab(tab);
            }}
          />
        </Box>

        <Box>
          {selectedTab === PerfilTabsRoutes.DadosPessoais ? (
            <DadosPessoaisTab />
          ) : null}

          {selectedTab === PerfilTabsRoutes.Endereco ? <EnderecoTab /> : null}

          {selectedTab === PerfilTabsRoutes.TrocarSenha ? (
            <TrocarSenhaTab />
          ) : null}
        </Box>
      </Grid>
    </Container>
  );
}

export default EditarPerfilTabs;
